export const CONFIG_GOVERNANCE = 'Governance'
export const CONFIG_RISK = 'Risk'
export const CONFIG_COMPLIANCE = 'Compliance'
export const CONFIG_HEATMAP = 'Heat Map'
export const CONFIG_INDICATOR = 'Indicator'
export const approvalStages = [
    {
        id: 'L1',
        checked: false,
        label: 'L1 Approver',
        labelInfo: 'Raised Department Head'
    },
    {
        id: 'L2',
        checked: false,
        label: 'L2 Approver',
        labelInfo: 'Risk Owned Department Head'
    }
]

export const GOVERNANCE_KIND_ID = 1
export const RISK_KIND_ID = 3
export const COMPLIANCE_KIND_ID = 2
export const HEAT_MAP_KIND_ID = 5

export const COMPLIANCE_INFO_DATA = [
    { label: 'Monthly Compliance', days: 31 },
    { label: 'Quarterly Compliance', days: 92 },
    { label: 'Half-Yearly Compliance', days: 183 },
    { label: 'Annual Compliance', days: 365 }
]

export const CONFIGURATION_MENU = [
    {
        kindId: 1,
        kindName: 'Governance'
    },
    {
        kindId: 3,
        kindName: 'Risk'
    },
    {
        kindId: 2,
        kindName: 'Compliance'
    }
    // {
    //     kindId: 5,
    //     kindName: 'Heat Map'
    // }
    // {
    //     kindId: 6,
    //     kindName: 'Indicator'
    // }
]
